import { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import {
  cleanObject,
  getRandomIntInclusive,
  getUrlQuerysection,
  bankAccountTypes,
} from "../../../helpers";
import {
  useCreateBankAccountMutation,
  useUpdateBankAccountMutation,
} from "../../../hooks/api/mutations/useAccounting";
import { useQueryClient } from "react-query";

const useBankAccountLogic = ({
  closeWidget,
  bankInfo,
  handleFetchAccountsList,
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const createBankAccountMutation = useCreateBankAccountMutation();
  const updateBankAccountMutation = useUpdateBankAccountMutation();
  const queries = getUrlQuerysection();
  const queryClient = useQueryClient();

  const [bankDetails, setBankDetails] = useState({
    account_name: bankInfo?.account_name || "",
    bank_name: bankInfo?.bank_name || "",
    account_number: bankInfo?.account_number || "",
    bank_account_type: bankInfo?.bank_account_type || "",
    description: bankInfo?.description || "",
    opening_balance: bankInfo?.opening_balance || "",
    balance_date: bankInfo?.balance_date || "",
  });

  const handleAddBank = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = { ...bankDetails };
    createBankAccountMutation.mutate(cleanObject(data), {
      onSuccess: () => {
        handleFetchAccountsList();
        queryClient.invalidateQueries(["getChartOfAccounts", queries]);
        triggerToast("Bank added successfully", "success");
        closeWidget();
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  // update bank
  const handleEditBank = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject(bankDetails);
    updateBankAccountMutation.mutate(
      { id: bankInfo?.id, data },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["getChartOfAccounts", queries]);
          queryClient.invalidateQueries([
            "getChartAccountDetails",
            bankInfo?.id,
          ]);
          handleFetchAccountsList();
          triggerToast("Bank updated successfully", "success");
          closeWidget();
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  return {
    bankDetails,
    bankAccountTypes,
    setBankDetails,
    storeList,
    handleAddBank,
    handleEditBank,
    updateBankAccountMutation,
    createBankAccountMutation,
  };
};

export default useBankAccountLogic;
